<template>
  <div class="row">
    <div class="col-xs-10">
      <div class="col-xs-4">
        <label class="">Criteria</label>
        <input class="form-control input-sm" v-model="metric.name" placeholder="Power consumption"/>
      </div>
      <div class="col-xs-4">
        <label class="" v-if="workflowId === 3">Common figure</label>
        <label class="" v-else>Common figure (SoA)</label>
        <input class="form-control input-sm" v-model="metric.current" placeholder="10 mW"/>
        <span class="help-block m-b-none"> State of the Art figure </span>
      </div>
      <div class="col-xs-4">
        <label v-if="workflowId === 3"> Achievable or achieved</label>
        <label v-else >Target</label>
        <input class="form-control input-sm" v-model="metric.target" placeholder="1 mW"/>
        <span class="help-block m-b-none" v-if="workflowId === 3"> Tech offer performance </span>
        <span class="help-block m-b-none" v-else> Objective </span>
      </div>
    </div>
    <div class="col-xs-2" style="margin: 25px 0">
      <button class="btn btn-xs btn-outline btn-danger" v-on:click="removeMetric($event, index)"><i class="fa fa-remove"></i> Delete</button>
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  name: 'Metrics',
  props: ['metric', 'removeMetric', 'index', 'workflowId'],
  data () {
    return {
    }
  },
  methods: {
  },
  beforeMount () {
  }

}
</script>



// WEBPACK FOOTER //
// src/components/question/Metrics.vue